import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

import ticketSettingsHostUtility from '../../utils/ticketSettingsHost.utility.js'

export const useTicketStore = defineStore('ticket', () => {
  const active = ref({ items: [], _meta: null })
  const archived = ref({ items: [], _meta: null })
  /** Deduped settings trees from list responses — keyed by `settingsHostKey`. */
  const settingsHosts = ref({})

  const isLoaded = computed(() => active.value._meta !== null)

  function replaceSettingsHosts(map) {
    settingsHosts.value = map && typeof map === 'object' ? { ...map } : {}
  }

  function mergeSettingsHosts(map) {
    if (!map || typeof map !== 'object') return
    const keys = Object.keys(map)
    if (!keys.length) return

    const next = { ...settingsHosts.value }
    for (const key of keys) {
      const incoming = map[key]
      const existing = next[key]
      if (
        ticketSettingsHostUtility.normalize(existing) &&
        !ticketSettingsHostUtility.normalize(incoming)
      ) {
        continue
      }
      next[key] = incoming
    }
    settingsHosts.value = next
  }

  const hydrate = {
    active(data) {
      active.value = { items: data.items, _meta: data._meta }
    },

    archived(data) {
      archived.value = { items: data.items, _meta: data._meta }
    },

    settingsHosts: {
      replace(map) {
        replaceSettingsHosts(map)
      },
      merge(map) {
        mergeSettingsHosts(map)
      },
    },
  }

  function reset() {
    active.value = { items: [], _meta: null }
    archived.value = { items: [], _meta: null }
    settingsHosts.value = {}
  }

  return {
    active,
    archived,
    settingsHosts,
    isLoaded,
    hydrate,
    replaceSettingsHosts,
    mergeSettingsHosts,
    reset,
  }
})
